import {
  LAMBDATEST_DELETE_BUILD_LOADING,
  LAMBDATEST_DELETE_BUILD_SUCCESS,
  LAMBDATEST_DELETE_BUILD_FAILED,
  LAMBDATEST_DELETE_BUILD_CLEAR
} from "../actionTypeConstants/lambdaBuildDeleteConstant";

const initialState = {
  buildDeleteState: {
    loading: false,
    data: null,
    error: null
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_DELETE_BUILD_LOADING:
      return {
        ...state,
        buildDeleteState: {
          ...state.buildDeleteState,
          loading: true,
          data: null,
          error: null
        }
      };
    case LAMBDATEST_DELETE_BUILD_SUCCESS:
      return {
        ...state,
        buildDeleteState: {
          ...state.buildDeleteState,
          loading: false,
          data: action.result.data,
          error: null
        }
      };
    case LAMBDATEST_DELETE_BUILD_FAILED:
      return {
        ...state,
        buildDeleteState: {
          ...state.buildDeleteState,
          loading: false,
          error: action.error.response,
          data: null
        }
      };
    case LAMBDATEST_DELETE_BUILD_CLEAR:
      return {
        ...state,
        buildDeleteState: {
          ...state.buildDeleteState,
          loading: false,
          data: null,
          error: null
        }
      };
    default:
      return state;
  }
}
